import type { CSSProperties } from 'react'
import { FiRefreshCw } from 'react-icons/fi'
import { useRefreshCurrentTab } from '../../hooks/useRefreshCurrentTab'
import { useTranslation } from '../../hooks/useTranslation'

type PageRefreshButtonProps = {
  className?: string
  iconSize?: number
  stopPropagation?: boolean
  style?: CSSProperties
}

export default function PageRefreshButton({
  className,
  iconSize = 16,
  stopPropagation = false,
  style,
}: PageRefreshButtonProps) {
  const { refresh, isRefreshing } = useRefreshCurrentTab()
  const { translate } = useTranslation()

  return (
    <button
      type="button"
      onClick={(e) => {
        if (stopPropagation) e.stopPropagation()
        void refresh()
      }}
      disabled={isRefreshing}
      className={className}
      style={style}
      title={translate('tabs.refresh')}
      aria-label={translate('tabs.refresh')}
    >
      <FiRefreshCw
        size={iconSize}
        strokeWidth={2.5}
        className={isRefreshing ? 'animate-spin' : ''}
      />
    </button>
  )
}
